import * as React from 'react'
import {Link} from '@frontrow/console/src/components/ui/link'

export function SalesReportsPage(): React.ReactElement {
  return (
    <React.Fragment>
      <p>
        This page contains links to Freckle Periscope dashboards. To view a dashboard, click a link
        and put in the password.
      </p>
      <p>
        Password: <b>salesisawesome</b>
      </p>
      <ul>
        <ReportLink
          name="Ultimate Sales Dashboard"
          url="https://app.periscopedata.com/shared/d2f2181b-cca1-4ac3-bd05-3eeccb5d1599"
          dataTest="ultimate-sales-dashboard-link"
        />
        <ReportLink
          name="New Business Enablement"
          url="https://app.periscopedata.com/shared/b21ef480-1f02-449a-866c-52a690c0598b"
          dataTest="new-business-enablement-link"
        />
        <ReportLink
          name="School Usage Overview"
          url="https://app.periscopedata.com/shared/89220cee-c907-4951-85ea-c11ee8864c55"
          dataTest="school-usage-overview-link"
        />
        <ReportLink
          name="Schools within 200 miles"
          url="https://app.periscopedata.com/shared/07e17f75-94dc-4608-912e-e19e28a07dab"
          dataTest="schools-within-200-miles-link"
        />
        <ReportLink
          name="Freckle Usage for Schools with Other Renaissance Products"
          url="https://app.periscopedata.com/shared/32a5d1cd-c895-4303-8f8d-87dab0b0b3d9"
          dataTest="freckle-usage-other-renaissance-products-link"
        />
        <ReportLink
          name="Freckle Impact Report Data"
          url="https://app.periscopedata.com/shared/8d54a9a3-9be2-456a-8c15-5f96df5f5203"
          dataTest="freckle-impact-report-data-link"
        />
      </ul>
    </React.Fragment>
  )
}

const ReportLink = (props: {name: string; url: string; dataTest: string}): React.ReactElement => {
  const {name, url, dataTest} = props
  return (
    <li>
      <Link href={url} dataTest={dataTest} target="_blank" rel="noopener">
        {name}
      </Link>
    </li>
  )
}
